export default __webpack_public_path__ + "static/media/Mockup3.6facac37.png";